import { tv } from '@/utils/styles';

export const routeSegmentPanelStyles = tv({
  slots: {
    bold: 'font-medium',
    rowPrimaryText: 'm-0 text-baseSm font-medium leading-[16px] text-text-primary',
    rowSubText: 'mb-0 mt-1 text-xs leading-[12px] text-text-secondary',
  },
});
